import axios from 'axios'
const API_URL = 'https://back-scoring.wift.cl/'

export function authenticate (userData) {
    return axios.post(`${API_URL}/login/`, userData)
  }
  
  export function register (userData) {
    return axios.post(`${API_URL}/register/`, userData)
  }